import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BasicFormFields, CommonService, Config, FieldsService, FIELD_TYPE, FormBaseField, ToastService, SessionController } from '@increff/commons';
import packageJson from 'package.json';
@Component({
    selector: 'com-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

    @ViewChild('applicationHelperTextRef') applicationHelperTextRef: TemplateRef<any>;

    uiVersion = packageJson?.version;
    applicationFormModel: {[key: string]: BasicFormFields};
    applicationFormFields: FormBaseField[] = [];
    constructor(
        private toast: ToastService,
        private fieldsService: FieldsService,
        private commonService: CommonService,
        private config: Config,
        private sessionController: SessionController
    ){
    }

    ngAfterViewInit(): void {
        this.applicationFormModel = {
            appName: {
                type: FIELD_TYPE.TEXT,
                key: 'appName',
                label: 'Application',
                containerClass: 'col-12',
                extraTemplate: this.applicationHelperTextRef
            },
        };
        this.applicationFormFields = this.fieldsService?.getFormFields(this.applicationFormModel);
        this.commonService?.initTooltip('com-landing');
    }

    submitForm(formSpy: NgForm) {
        if(formSpy?.invalid) {
            this.toast?.warn('Application is required!');
            return;
        }
        window.location.href = this.getLoginRedirectionUrl(formSpy);
    }

    getLoginRedirectionUrl(formSpy?: NgForm): string {
        return `${this.config?.startupData?.loginUrl}/auth/login?appName=${formSpy?.value?.appName || 'auth'}${!formSpy ? '&domainName=auth' : ''}&authNextUrl=/${formSpy?.value?.appName ? 'domain' : 'admin'}-login`;
    }

}
